var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{attrs:{"src":"data:image/svg+xml,%3Csvg xmlns=\"http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\"%3E%3Cpath fill=\"darkgray\" d=\"M3 18v-2h18v2H3Zm0-5v-2h18v2H3Zm0-5V6h18v2H3Z\"%2F%3E%3C%2Fsvg%3E"}})
}
var staticRenderFns = []

export { render, staticRenderFns }